import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface CycleSignalsResponse {
  has_highlights: boolean;
  has_smart_trawl_papers: boolean;
  has_claims: boolean;
  has_claims_with_evidence: boolean;
  surface_gaps_enacted: boolean;
  refine_enacted: boolean;
  audit_enacted: boolean;
  drill_enacted: boolean;
  has_chat_messages: boolean;
  first_highlighted_paper_id: string | null;
}

/** Extracted so the key/enabled logic is unit-testable without a renderer. */
export function cycleSignalsQueryOptions(conceptId: string | undefined) {
  return {
    queryKey: ["cycle-signals", conceptId] as const,
    queryFn: () =>
      apiClient.get(`api/concepts/${conceptId}/cycle-signals`).json<CycleSignalsResponse>(),
    enabled: !!conceptId,
  };
}

export function useCycleSignals(conceptId: string | undefined) {
  return useQuery(cycleSignalsQueryOptions(conceptId));
}
